export default {
  useNewCheckout: true,
  api: {
    mode: 'cors',
    weburl:'https://stag.beublog.com/',
    v2: 'https://apistagv2.beublog.com/api/v2/',
    v2BaseUrl:'https://apistagv2.beublog.com/'
  },
  socket: '',
  google_map_key:'AIzaSyAxx2cDzRRwbsY99ey2-G6gHVQpTwA4N_Y',
  apple_redirectURI:"https://apistagv2.beublog.com/api/v2/user/apple/callback",
  simulated:false,
  noClientDAta : {
    "_id" : "64f5c7789a069cda0188fea3",
    "userImage" : {
        "rectangleImage" : "",
        "circleImage" : ""
    },
    "facebookId" : 0,
    "phoneNumber" :"44325325345325",
    "genderId" : 0,
    "latitude" : 28.640004,
    "longitude" : 77.376707,
    "localAvatar" : "",
    "socialAvatar" : "",
    "useAvatarType" : 0,
    "deviceTypeId" : 2,
    "deviceToken" : "",
    "defaultRedirectTo" : 0,
    "isRemoved" : false,
    "password" : "$2a$10$64EZXccFWloQrqpmKOnTCeD8.oVdt8MogCVPSJtNvgIRlUqIuDvvG",
    "stripeCustomer" : "",
    "stripeConnectedAccount" : "",
    "dob" : "",
    "status" : 1,
    "emailNotification" : true,
    "smsNotification" : true,
    "email" : "64f5c7789a069cda0188fea3@beuapp.com",
    "first_name" : "Walk",
    "last_name" : "In",
    "name" : "Walk In",
    "createdTime" : "2023-09-04T17:33:04.686+05:30",
    "updatedTime" : "2023-09-04T17:34:07.885+05:30",
    "__v" : 0
}
}